import {
  LeaderboardsAccordion,
  LeaderboardsAccordionProps,
} from './LeaderboardsAccordion';

export type LeaderboardsProps = Omit<
  LeaderboardsAccordionProps,
  'chosenLeaderboard'
> & {
  chosenLeaderboard: string;
};

export function Leaderboards({
  leaderboards,
  chosenLeaderboard,
}: LeaderboardsProps) {
  return (
    <>
      <LeaderboardsAccordion
        chosenLeaderboard={chosenLeaderboard}
        leaderboards={leaderboards}
      />
    </>
  );
}
